import React from "react";
import {
  SquareFoot as SquareFootIcon,
  Thermostat as ThermostatIcon,
  Science as ScienceIcon,
  Visibility as VisibilityIcon,
  Palette as PaletteIcon,
} from "@mui/icons-material";
import { PropertyGroup } from "../../types/recipe";

/**
 * Returns the URL for a given Creative Commons license name.
 * @param {string} license The full name of the Creative Commons license.
 * @returns {string} The URL for the license, or a default URL if not found.
 */
export const renderLicenseLink = (license: string): string => {
  const licenseLinks: { [key: string]: string } = {
    "Creative Commons: Attribution-NoDerivatives 4.0 International (CC BY-ND 4.0)":
      "https://creativecommons.org/licenses/by-nd/4.0/",
    "Creative Commons: Attribution-ShareAlike 4.0 International (CC BY-SA 4.0)":
      "https://creativecommons.org/licenses/by-sa/4.0/",
    "Creative Commons: Attribution-NonCommercial 4.0 International (CC BY-NC 4.0)":
      "https://creativecommons.org/licenses/by-nc/4.0/",
    "Creative Commons: Attribution-NonCommercial-NoDerivatives 4.0 International (CC BY-NC-ND 4.0)":
      "https://creativecommons.org/licenses/by-nc-nd/4.0/",
    "Creative Commons: Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0)":
      "https://creativecommons.org/licenses/by-nc-sa/4.0/",
    "Creative Commons: Attribution 4.0 International (CC BY 4.0)":
      "https://creativecommons.org/licenses/by/4.0/",
  };
  return (
    licenseLinks[license] ||
    "https://creativecommons.org/licenses/by-sa/4.0/deed.en"
  );
};

/**
 * Returns a Material-UI icon component based on a property name.
 * @param {string} name The name of the property.
 * @returns {JSX.Element} A Material-UI icon component.
 */
export const getPropertyIcon = (name: string): JSX.Element => {
  switch (name.toLowerCase()) {
    case "density":
    case "moisture content":
      return React.createElement(SquareFootIcon, { color: "primary" });
    case "tensile strength - ultimate":
    case "yield strength":
    case "youngs modulus":
      return React.createElement(ScienceIcon, { color: "primary" });
    case "opacity":
      return React.createElement(VisibilityIcon, { color: "primary" });
    case "degradation temperature":
    case "thermal stability":
      return React.createElement(ThermostatIcon, { color: "primary" });
    default:
      return React.createElement(PaletteIcon, { color: "primary" });
  }
};

// Utility to filter non-empty property items
export function getFilteredProperties(groups: PropertyGroup[]): any[] {
  return groups.flatMap((group) =>
    group.properties.filter(
      (property) =>
        property.items &&
        property.items.length > 0 &&
        property.items[0].value !== null
    )
  );
}
